// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

require('tablesorter');

import { getTagsAsMap } from '@confluence/meta';

const dateFormat = getTagsAsMap()['date.format'];

/**
 * isTableSorterAlreadyEnabled will return a boolean for the already enabled sortable state of a table
 *
 * @param {HtmlElement} table Html table element
 * @return {Boolean} SortableTables enabled state for table
 */
const isTableSorterAlreadyEnabled = function (table) {
	return table.className.indexOf('tablesorter') > -1;
};

/**
 * isTheadDirectVisibleChild - is thead present as the visible direct child of a table
 *
 * @param {HtmlElement} table Html table element
 * @return {Boolean}
 */
const isTheadDirectVisibleChild = function (table) {
	return $(table).find('> thead:first').is(':visible');
};

//Sortable tables friendly date format
function getDateFormat() {
	let firstCharacter;
	let retVal;

	if (dateFormat && dateFormat.length !== 0) {
		//we can assume enough from the first character
		firstCharacter = dateFormat.toLowerCase()[0];
		if (firstCharacter === 'm') {
			retVal = 'mmddyyyy';
		} else if (firstCharacter === 'd') {
			retVal = 'ddmmyyyy';
		} else if (firstCharacter === 'y') {
			retVal = 'yyyymmdd';
		}
	}
	return retVal;
}

const sortableTable = {
	/**
	 * Setup a reference for the sortable table elements
	 */
	init: (table) => {
		sortableTable.enable(table);
	},
	shouldSort: (table) => {
		const $table = $(table);
		const $cells = $table.find('td, th');
		const $firstRowCells = table.rows.length && $(table.rows[0].cells);
		let cell;

		// if disabled or already enabled
		if (
			$table.attr('data-sortable') === 'false' ||
			isTableSorterAlreadyEnabled(table) || // If we already enabled tablersorter we should skip
			isTheadDirectVisibleChild(table)
		) {
			return false;
		}

		// this exists for legacy reasons, we use a data attribute to opt out now
		const eventData = $.Event('makeSortable.SortableTables');
		$table.trigger(eventData);
		if (eventData.isDefaultPrevented()) {
			return false;
		}

		if (!$firstRowCells || $firstRowCells.length === 0) {
			//there are no rows or no cells
			return false;
		}
		//no colspan or rowspans > 1
		for (let i = 0, len = $cells.length; i < len; i++) {
			cell = $cells[i];
			if (cell.rowSpan != 1 || cell.colSpan != 1) {
				return false;
			}
		}

		//Header contains an inner table, not sortable
		if ($(table.rows[0]).find('table').length) {
			return false;
		}

		// at least one cell in first row is not a th or have a class of nohighlight, not sortable
		if (
			$firstRowCells.filter('th').length !== $firstRowCells.length ||
			$firstRowCells.hasClass('nohighlight')
		) {
			return false;
		}

		// single row tables are not sortable
		return table.rows[1];
	},
	/**
	 * Enables sorting for the stored table reference, needs to be called after init has run at least once.
	 */
	enable: (table) => {
		if (!sortableTable.shouldSort(table)) {
			return;
		}

		// Changing this to use live dom nodes or something other than a document fragment has a
		// significant performance penalty. Modify with care.
		const tableBody = table.removeChild(table.tBodies[0]);
		const $rows = $(tableBody.children);
		const firstRow = Array.prototype.shift.call($rows);
		const fragment = document.createDocumentFragment();
		const tableHead = document.createElement('thead');

		fragment.appendChild(tableHead);
		tableHead.appendChild(firstRow);
		fragment.appendChild(tableBody);

		table.appendChild(fragment);

		const $table = $(table);
		$table.tablesorter({
			// get headers option from 'data-tablesorter-headers'
			headerTemplate: '',
			headers: $table.data('tablesorterHeaders'),
			cssHeader: 'sortableHeader',
			cssAsc: 'tablesorter-headerSortUp',
			cssDesc: 'tablesorter-headerSortDown',
			delayInit: true,
			textExtraction: (node) => {
				const $node = $(node);
				if ($node.attr('data-sort-value')) {
					return $node.attr('data-sort-value');
				}

				//Do the text trim manually since our version of jQuery fails at this.
				return $node.text().trim();
			},
			dateFormat: getDateFormat(),
		});
	},
};

export default sortableTable;
